import { useContext, useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import { set } from "lodash";
import { CreateResponsavelType, EditResponsavelType } from "./useResponsavel";
import Swal from "sweetalert2";

export interface InstituicaoType {
    id: number
    name: string;
    email: string;
    cep?: string;
    state?: string;
    city?: string;
    neighborhood?: string;
    address?: string;
    number?: number;
    directorPhone?: string;
    isPrivate?: boolean;
    pix?: string;
    // userId: number;
    empresaId: number;
}

export interface CreateInstituicaoType {
    name: string;
    email: string;
    CEP?: string;
    state?: string;
    city?: string;
    neighborhood?: string;
    address?: string;
    number?: number;
    directorPhone?: string;
    isPrivate?: boolean;
    pix?: string;
    password: string;
    idEmpresa: number;
    responsavel?: CreateResponsavelType[];
}

export interface EditInstituicaoType {
    id: number;
    name: string;
    email: string;
    CEP?: string;
    state?: string;
    city?: string;
    neighborhood?: string;
    address?: string;
    number?: number;
    directorPhone?: string;
    isPrivate?: boolean;
    pix?: string;
    password: string;
    responsavel?: EditResponsavelType[];
}

export default function useInstituicao() {
    const showToast = useToast();
    const { setLoading } = useContext(LoadingContext);
    const { handleLogout, objUserTk } = useContext(AuthContext);
    const [listInstituicao, setListInstituicao] = useState<InstituicaoType[]>([]);
    const [pageCount, setPageCount] = useState<number>(0);
    const [initialListInstituicao, setInitialListInstituicao] = useState<InstituicaoType[]>([]);
    const [instituicao, setInstituicao] = useState<InstituicaoType>({
        id: 0,
        name: "",
        email: "",
        cep: "",
        state: "",
        city: "",
        neighborhood: "",
        address: "",
        number: 0,
        directorPhone: "",
        isPrivate: false,
        pix: "",
        // userId: 0,
        empresaId: 0,
    });

    // function createInstituicao(createInstituicaoType: CreateInstituicaoType): Promise<CreateInstituicaoType | null> {
    //     setLoading(true);
    //     console.log("createInstituicaoType: ", createInstituicaoType);
    //     return api
    //         .post(`/Instituicao/create`, createInstituicaoType)
    //         .then((response) => {
    //             const createdInstituicao: CreateInstituicaoType = response.data;
    //             showToast("success", "Instituição criado com sucesso.");
    //             setLoading(false);
    //             return createdInstituicao;
    //         })
    //         .catch((error) => {
    //             if (error?.response?.status === 401) {
    //                 handleLogout();
    //                 showToast(
    //                     "error",
    //                     "Sessão desconectada. Favor login novamente.",
    //                     error
    //                 );
    //             } else {
    //                 showToast(
    //                     "error",
    //                     "Erro ao criar instituição. Verifique novamente mais tarde.",
    //                     error
    //                 );
    //             }
    //             setLoading(false);
    //             console.error("Erro ao criar instituição:", error);
    //             return null;
    //         });
    // }

    function createInstituicao(createInstituicaoType: CreateInstituicaoType): Promise<CreateInstituicaoType | null> {
        setLoading(true);

        return api
            .post(`/Instituicao/create`, createInstituicaoType)
            .then((response) => {
                const createdInstituicao: CreateInstituicaoType = response.data;
                showToast("success", "Instituição criada com sucesso.");
                setLoading(false);
                return createdInstituicao;
            })
            .catch((error) => {
                if (error?.response?.status === 409) {
                    // duplicado
                    const msg =
                        error?.response?.data?.message ||
                        "Já existe uma instituição cadastrada com esse nome ou e-mail.";

                    // aqui eu NÃO uso toast, porque você pediu swal
                    Swal.fire({
                        icon: "error",
                        title: "Instituição já cadastrada",
                        text: msg,
                        confirmButtonText: "OK",
                    });

                    setLoading(false);
                    return null;
                }

                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast("error", "Sessão desconectada. Favor login novamente.", error);
                } else {
                    showToast("error", "Erro ao criar instituição. Verifique novamente mais tarde.", error);
                }

                setLoading(false);
                console.error("Erro ao criar instituição:", error);
                return null;
            });
    }

    function getInstituicaoPaged(
        pageNumber: number,
        Name?: string,
        EmpresaId?: number,
        pageSize?: number,
        isPrivate?: boolean,
        region?: string
    ): Promise<InstituicaoType[] | null> {
        setLoading(true);
        let url = `/Instituicao/getInstituicaoPaged?pageNumber=${pageNumber}&pageSize=${pageSize}`;

        if (Name) {
            url += `&Name=${Name}`;
        }

        if (EmpresaId) {
            url += `&EmpresaId=${EmpresaId}`;
        }

        if (isPrivate !== undefined) {
            url += `&IsPrivate=${isPrivate}`;
        }

        if (region) {
            url += `&Region=${region}`;
        }

        return api
            .get(url)
            .then((response) => {
                setListInstituicao(response.data.result);
                setInitialListInstituicao(response.data.result);
                setPageCount(response.data.pageCount);
                setLoading(false);
                return response.data.result;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao carregar instituição. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao carregar instituição:", error);
                return null;
            });
    }

    function updateInstituicao(updateInstituicaoData: EditInstituicaoType): Promise<EditInstituicaoType | null> {
        setLoading(true);
        return api
            .put(`/Instituicao/${updateInstituicaoData.id}`, updateInstituicaoData)
            .then((response) => {
                showToast("success", "Instituição atualizada com sucesso.");
                setLoading(false);
                return response.data;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao atualizar instituição. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao atualizar instituição:", error);
                return null;
            });
    }

    function deleteInstituicao(instituicaoId: number): Promise<InstituicaoType | null> {
        setLoading(true);
        return api
            .delete(`/Instituicao/delete/${instituicaoId}`)
            .then(() => {
                setInstituicao({
                    id: 0,
                    name: "",
                    email: "",
                    cep: "",
                    state: "",
                    city: "",
                    neighborhood: "",
                    address: "",
                    number: 0,
                    directorPhone: "",
                    isPrivate: false,
                    pix: "",
                    // userId: 0,
                    empresaId: 0,
                });
                showToast("success", "Instituição deletada com sucesso.");
                setLoading(false);
                return null;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao deletar instituição. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao deletar instituição:", error);
                return null;
            });
    }

    function handleGetInstituicaoByUserId(userId: number): Promise<InstituicaoType | null> {
        setLoading(true);
        return api
            .get(`/Instituicao/getInstituicaoByUserId/${userId}`)
            .then((response) => {
                const instituicao: InstituicaoType = response.data;
                setInstituicao(instituicao);
                setLoading(false);
                return instituicao;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar informações da instituição. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar informações do instituição:", error);
                return null;
            });
    }

    function handleGetInstituicaoById(instituicaoId: number): Promise<InstituicaoType | null> {
        setLoading(true);
        return api
            .get(`/Instituicao/${instituicaoId}`)
            .then((response) => {
                const instituicao: InstituicaoType = response.data;
                setInstituicao(instituicao);
                setLoading(false);
                return instituicao;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar instituição pelo ID. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar instituição pelo ID:", error);
                return null;
            });
    }

    function handleGetInstituicaoByEmpresaId(empresaId: number): Promise<InstituicaoType[] | null> {
        setLoading(true);
        return api
            .get(`/Instituicao/getInstituicaoByEmpresaId/${empresaId}`)
            .then((response) => {
                const instituicao: InstituicaoType[] = response.data;
                setListInstituicao(instituicao);
                setLoading(false);
                return instituicao;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar instituições. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar instituições pelo ID:", error);
                return null;
            });
    }

    return {
        createInstituicao,
        getInstituicaoPaged,
        updateInstituicao,
        deleteInstituicao,
        handleGetInstituicaoByUserId,
        handleGetInstituicaoById,
        setListInstituicao,
        listInstituicao,
        setPageCount,
        pageCount,
        setInitialListInstituicao,
        initialListInstituicao,
        setInstituicao,
        instituicao,
        handleGetInstituicaoByEmpresaId,
    };
}
